import { COLORS } from '../../constants/theme';

interface SectionHeaderProps {
  title: string;
  rightContent?: React.ReactNode;
  accent?: string;  // Left color bar (hex) — required on multi-section pages
  level?: 2 | 3 | 4;  // Heading level (default: 3)
}

export function SectionHeader({ title, rightContent, accent, level = 3 }: SectionHeaderProps) {
  const Tag = `h${level}` as 'h2' | 'h3' | 'h4';

  return (
    <div
      className="flex items-center justify-between px-3 py-2"
      style={{
        backgroundColor: COLORS.sectionHeader,
        borderBottom: `1px solid ${COLORS.border}`,
        borderLeft: accent ? `3px solid ${accent}` : undefined,
      }}
    >
      <Tag
        className="text-xs font-bold tracking-widest uppercase"
        style={{ color: COLORS.text.secondary }}
      >
        {title}
      </Tag>
      {rightContent && (
        <span className="text-xs" style={{ color: COLORS.text.tertiary }}>
          {rightContent}
        </span>
      )}
    </div>
  );
}
